import React from "react";

import { FlipbookBlock as Value } from "@reactivated";

import styles from "./index.module.scss";

interface Props {
    value: Value;
}

export const FlipbookBlock = ({ value }: Props) => {
    if (!value.url) return <></>;

    return (
        <div className={styles.root}>
            <div className={styles.inner}>
                <iframe
                    src={value.url}
                    width="100%"
                    height="100%"
                    seamless={true}
                    scrolling="no"
                    frameBorder="0"
                    allowFullScreen
                    allow="autoplay; clipboard-read; clipboard-write"
                />
            </div>
        </div>
    );
};
